<template>
<div>
  <el-row class="title-bar vertical-center-box ">
    <div class="title-h4">수집 서버 그룹</div>
    <div class="setting-addel mr-l15">
      <el-button size="mini" @click="clickAddAgentGroupButton"><i class="fas fa-plus"></i></el-button>
      <el-button size="mini" @click="clickDeleteAgentGroupButton" :disabled="deletedRecords.length < 1"><i class="fas fa-minus"></i></el-button>
    </div>
  </el-row>
  <el-table-wrapper class="mr-b20" ref="agentGroupTable" row-class-name="c-dblclick" :data="agentGroupTableData" :columns="agentGroupTableColumns" :column-default="columnDefault" @cell-dblclick="onDblclickRow" @row-click="clickRow" highlight-current-row
    header-align="center" :pagination="false" @selection-change="onSelectRow" style="width:100%;">
  </el-table-wrapper>
  <w-add-agent-group-popup ref="addAgentGroupPopup" @reload-data="loadData"></w-add-agent-group-popup>
  <w-update-agent-group-popup ref="updateAgentGroupPopup" @reload-data="loadData" :selected-row="selectedRow"></w-update-agent-group-popup>
</div>
</template>

<script>
import isNil from 'lodash/isNil';
import cloneDeep from 'lodash/cloneDeep';
import { columnDefault } from '@/constants/table';
import msgUtil from '@/utils/message';
import AgentSettingsAPI from '@/api/settings/common/agent-settings';
import WAddAgentGroupPopup from '../popup/AddAgentGroupPopup';
import WUpdateAgentGroupPopup from '../popup/UpdateAgentGroupPopup';

export default {
  name: 'WAgentGroupTable',
  components: {
    WAddAgentGroupPopup,
    WUpdateAgentGroupPopup,
  },
  data() {
    return {
      columnDefault,
      agentGroupTableColumns: [
        {
          type: 'selection',
        },
        {
          prop: 'agentManagerGroupId',
          label: '그룹번호',
          width: 80,
        },
        {
          prop: 'agentManagerGroupName',
          label: '그룹명',
        },
      ],
      agentGroupTableData: [],
      selectedRow: null,
      deletedRecords: [],
    };
  },
  watch: {
    selectedRow(row) {
      if (!isNil(row)) {
        this.$emit('get-agent-manager-group-id', row.agentManagerGroupId);
      }
    },
  },
  methods: {
    loadData() {
      AgentSettingsAPI.getAgentGroupList().then((response) => {
        const result = response.data.data.list;
        this.agentGroupTableData = cloneDeep(result);
        if (isNil(this.selectedRow)) {
          this.selectedRow = this.agentGroupTableData[0];
        } else {
          const selectedRow = this.agentGroupTableData.find((row) => this.selectedRow.agentManagerGroupId === row.agentManagerGroupId);
          this.selectedRow = !isNil(selectedRow) ? selectedRow : this.agentGroupTableData[0];
        }
        this.$refs.agentGroupTable.$children[0].setCurrentRow(this.selectedRow);
      });
    },
    clickRow(row) {
      this.selectedRow = row;
    },
    clickAddAgentGroupButton() {
      this.$refs.addAgentGroupPopup.$refs.slidingPopup.visible = true;
    },
    clickDeleteAgentGroupButton() {
      const action = msgUtil.action.DELETE;
      const target = '수집 서버 그룹';
      this.$confirm(...msgUtil.getBasicConfirmData(action)).then(() => {
        AgentSettingsAPI.deleteAgentGroup(this.deletedRecords)
          .then((response) => {
            if (response.data.success) {
              this.$message(msgUtil.getResultMsgData(action, target, true));
              this.loadData();
            } else {
              this.$message(msgUtil.getResultMsgData(action, target, false));
            }
          })
          .catch(() => {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          });
      });
    },
    onDblclickRow(row, column) {
      if (column.type === 'selection') {
        return;
      }
      this.selectedRow = cloneDeep(row);
      this.$refs.updateAgentGroupPopup.$refs.slidingPopup.visible = true;
    },
    /**
     * 삭제할 대상 선택
     * @param  {[type]} record [description]
     * @return {[type]}        [description]
     * @author jda
     */
    onSelectRow(record) {
      this.deletedRecords = record;
    },
  },
};
</script>

<style scoped>
.title-table {
  //padding: 10px 0px 10px 0px;
  padding-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/settings/operation/CollectionSettings/AgentSettings/components/AgentGroupTable.vue